// extracted by mini-css-extract-plugin
export var deliveryRow = "_p3-a";
export var fixedHeight = "_p3-4";
export var freightLogo = "_p3-9";
export var fullWidth = "_p3-3";
export var priceColumn = "_p3-5";
export var radioSelected = "_p3-7";
export var radioUnselected = "_p3-6";
export var selectedOption = "_p3-2";
export var selectedOptionContainer = "_p3-1";
export var selection = "_p3-0";
export var tallSkeletonText = "_p3-8";